export default __webpack_public_path__ + "static/media/playmusic.56c9a009.png";